/* eslint-disable import/default */
import Vue from 'vue';

import VueResource from 'vue-resource';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
// import VueClipboard from 'v-clipboard';

import meta from 'plugins/meta'; // eslint-disable-line no-unused-vars
import scroll from 'plugins/scroll'; // eslint-disable-line no-unused-vars
/* eslint-enable import/default */

Vue.use(VueResource);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);
// Vue.use(VueClipboard);



// WEBPACK FOOTER //
// ./client/plugins/index.js